export function getEventParticipationSubmissionState(event) {
    const enabled = Boolean(event?.eventParticipationSubmissionsEnabled);
    const open = enabled && (event?.eventParticipationSubmissionsOpen ?? event?.eventParticipationSubmissionsEnabled);

    return {
        enabled,
        open,
    };
}
